<template>
  <poster-dashboard-widget
    :class="{ 'poster-dashboard-shortcut poster-dashboard-shortcut__root': true, disabled }"
    v-bind="$attrs"
  >
    <pui-flex class="poster-dashboard-shortcut__meta" direction="column">
      <div class="poster-dashboard-shortcut__header">
        <span
          v-if="picto"
          :class="{
            'poster-dashboard-widget__icon poster-dashboard-shortcut__icon mdi': true,
            [picto]: !!picto,
          }"
        />
        <span class="poster-dashboard-widget__title poster-dashboard-shortcut__title">
          <slot name="title"></slot>
        </span>
      </div>
      <p class="poster-dashboard-shortcut__subtitle">
        <slot name="subtitle"></slot>
      </p>
      <div class="poster-dashboard-shortcut__action"><slot name="button"></slot></div>
    </pui-flex>
    <pui-flex class="poster-dashboard-shortcut__image" justifyContent="center" alignItems="center">
      <slot name="image"></slot>
    </pui-flex>
  </poster-dashboard-widget>
</template>

<script>
export default {
  name: 'poster-dashboard-shortcut',
  props: {
    /**
     * Header icon
     */
    picto: {
      type: String,
      default: '',
    },
    /**
     * Disables the shortcut and prevents any clicks
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
